import StaticHeader from "../../../layout/header/static-header";

export default StaticHeader;
